module.exports = __webpack_public_path__ + "img/onboard.534ca688.jpg";